import { COURSE_TYPE } from '../../constants';

const courseTypes = Object.values(COURSE_TYPE).join('/');

export const allowedCourses = [COURSE_TYPE.DATA_SCIENCE, COURSE_TYPE.WEB3];

export const allowedPaymentMode = ['pay_upfront', 'pay_after_placement'];

const allowedPaymentModeString = allowedPaymentMode.join('/');

export const couponsValidationText = {
  EMPTY: 'Field is Null',
  INVALID_GOAL_TYPE: `Invalid Goal Type, allowed [${courseTypes}]`,
  INVALID_PAYMENT_MODE: `Invalid payment mode, allowed [${allowedPaymentModeString}]`,
};
